module.exports = __webpack_public_path__ + "static/media/mdi_keyboard_arrow_left.9a56c098.svg";